import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  @Output() setPageChange = new EventEmitter();

  @Input() dataLength: number;
  @Input() itemsCount: number;
  @Input() itemsPerPage: number;
  @Input() currentPage: number;

  constructor() { }

  ngOnInit() {
  }

  pageChange(num: number, flag: boolean = false) {
    if (this.currentPage < 1) {
      this.currentPage = 1;
      num = 1;
    }
    this.setPageChange.emit({ page: num, flag: flag });
  }

}
